<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'

//emits
const emit = defineEmits(['handleSelectItem']);

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//props
interface Props {
  item: any,
  selectedItems: any[]
  activeCollectionName: string
}
const props = withDefaults(defineProps<Props>(), {
  item: {},
  selectedItems: () => [],
  activeCollectionName: ''
})


const handleSelectItem = () => {
    emit('handleSelectItem', { item: props.item });
}
const isSelected = (item: any) => {
    return props.selectedItems.some((selectedItem) => selectedItem.doc_id === item.doc_id);
}
</script>
<template>
    <div class="doc-attr">
        <div class="doc-action--select-item">
            <img v-if="!isSelected(item)" src="@/assets/img/icon-checkbox.svg" @click="handleSelectItem"/>
            <img v-if="isSelected(item)" src="@/assets/img/icon-checkbox-active.svg" @click="handleSelectItem"/>
        </div>
        <div class="doc-attr--wrapper">
            <!-- <div  v-if="item.myDoc && item.myDoc === 'Y'" class="doc-attr--icon">
                <img src="@/assets/img/icon-search-result-my-doc.svg">
            </div> -->
            <div  v-if="item.docs && item.docs === 'Y'" class="doc-attr--icon">
                <img :title="t('docDocsAvail')" src="@/assets/img/icon-search-result-download.svg">
            </div>
            <div  v-if="item.lawlex && item.lawlex === 'Y'" class="doc-attr--icon">
                <img :title="t('docLawlex')" src="@/assets/img/icon-search-result-lawlex.svg">
            </div>
            <div v-if="(item.recently_created && item.recently_created === 'Y') ||  (item.recently_modifed && item.recently_modifed === 'Y')" class="doc-attr--icon">
                <img v-if="(item.recently_created && item.recently_created === 'Y')" :title="t('docCreated')" src="@/assets/img/icon-search-result-alert.svg">
                <img v-if="(item.recently_modifed && item.recently_modifed === 'Y')" :title="t('docModified')" src="@/assets/img/icon-search-result-alert.svg">
            </div>
            <div v-if="item.links && item.links === 'Y'" class="doc-attr--icon">
                <img :title="t('docLinksAvail')" src="@/assets/img/icon-search-result-link.svg">
            </div> 
            <div v-if="item.unpublished && item.unpublished === 'Y'" class="doc-attr--icon">
                <img :title="t('docUnpublished')" src="@/assets/img/icon-search-result-delete.svg">
            </div>
            <div v-if="item.notes && item.notes === 'Y'" class="doc-attr--icon">
                <img :title="t('docNotesAvail')" src="@/assets/img/icon-search-result-edit.svg">
            </div>
            <div v-if="item.collection && item.collection === 'Y'" class="doc-attr--icon">
                <img :title="t('docInCollection', [activeCollectionName])" src="@/assets/img/icon-search-result-addtocoll.svg">
            </div>
        </div>
    </div>
</template>